export type PublishReviewStep = 1 | 2 | 3 | 4;

export function canNavigateToPublishStep({
  currentStep,
  targetStep,
  currentStepComplete,
  isSubmitting,
}: {
  currentStep: PublishReviewStep;
  targetStep: PublishReviewStep;
  currentStepComplete: boolean;
  isSubmitting: boolean;
}): boolean {
  if (isSubmitting) return false;
  if (targetStep <= currentStep) return true;
  return targetStep === currentStep + 1 && currentStepComplete;
}
